import { render } from "./speakers.vue?vue&type=template&id=575b06e0&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=575b06e0&lang=scss&scoped=true"
import "./speakers.vue?vue&type=style&index=1&id=575b06e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-575b06e0"

export default script